import { Card } from '../ui/primitives';
import type { ProductsView } from '../../utils/reports/productsView';
import { ReportsNotes, ReportsSay } from './ReportsParts';
import { ReportsDetail, ReportsEmpty, ReportsSection, ReportsStats } from './ReportsPieces';

/**
 * P-084 · R3 «¿Qué productos me convienen?». Solo dibuja `ProductsView`: la frase, cuatro cifras, las cuatro listas
 * (sin un score único), la nota del margen y el detalle con todos los productos del periodo.
 */
export function ReportProducts({ view, onNavigate }: { view: ProductsView; onNavigate: (destination: string) => void }) {
  if (view.empty) {
    return (
      <>
        <ReportsSay segments={view.say} />
        <ReportsEmpty description={view.empty.description} title={view.empty.title} />
        <ReportsNotes notes={view.notes} />
      </>
    );
  }
  return (
    <>
      <ReportsSay segments={view.say} />
      <Card aria-labelledby="reports-products-stats" as="section" className="n3-reports__section">
        <h2 className="n3-visually-hidden" id="reports-products-stats">Productos, unidades, costo conocido y sin producto</h2>
        <ReportsStats stats={view.stats} />
        {view.marginNote && <p className="n3-reports__margin-note">{view.marginNote}</p>}
      </Card>
      <div className="n3-reports__rankings">
        {view.rankings.map((ranking) => (
          <ReportsSection icon="heart" key={ranking.key} onNavigate={onNavigate} section={{ key: ranking.key, title: ranking.title, rows: ranking.rows, empty: ranking.empty, note: null, more: null }} tone="warning" />
        ))}
      </div>
      <ReportsDetail id="reports-products-detail">
        {view.detail.map((section) => <ReportsSection icon="heart" key={section.key} onNavigate={onNavigate} section={section} tone="warning" />)}
      </ReportsDetail>
      <ReportsNotes notes={view.notes} />
    </>
  );
}
